import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";

const POINTS = ["30-day trial on paid plans", "No card required to start", "Works on phone in court"];

export const Hero = () => (
  <section
    data-testid="landing-hero"
    className="relative overflow-hidden border-b border-border/60 bg-[#FAFBFD] px-4 py-16 sm:px-6 sm:py-24 lg:px-8"
  >
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -right-40 -top-40 h-[28rem] w-[28rem] rounded-full bg-gold/10 blur-3xl"
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 opacity-[0.035]"
      style={{
        backgroundImage:
          "linear-gradient(#0A192F 1px, transparent 1px), linear-gradient(90deg, #0A192F 1px, transparent 1px)",
        backgroundSize: "56px 56px",
      }}
    />

    <div className="relative mx-auto max-w-6xl">
      <span className="inline-flex items-center gap-2 rounded-full border border-gold/30 bg-gold/15 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-gold-dark">
        Purpose-built for Indian legal practice
      </span>

      <h1 className="mt-6 max-w-4xl font-display text-4xl font-semibold leading-[1.08] tracking-tight text-navy sm:text-5xl lg:text-6xl">
        Every case, hearing and client in one diary. Built for Indian advocates.
      </h1>

      <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">
        Replace the paper diary, loose cause lists and case papers scattered across WhatsApp. Keep your
        matters, daily board, deadlines and documents in one place — across High Courts, District Courts
        and tribunals.
      </p>

      <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
        <Link
          to="/register"
          data-testid="hero-cta-register"
          className="group inline-flex items-center justify-center gap-2 rounded-md bg-gold px-7 py-3.5 text-base font-semibold text-navy shadow-md transition-all hover:-translate-y-0.5 hover:bg-gold-light"
        >
          Start your free trial
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Link>
        <Link
          to="/login"
          data-testid="hero-cta-login"
          className="inline-flex items-center justify-center rounded-md border border-navy/20 bg-white px-7 py-3.5 text-base font-medium text-navy transition-colors hover:border-navy/40 hover:bg-secondary"
        >
          Sign in
        </Link>
      </div>

      <ul className="mt-8 flex flex-col gap-2 sm:flex-row sm:gap-7">
        {POINTS.map((p) => (
          <li key={p} className="flex items-center gap-2 text-sm text-muted-foreground">
            <Check className="h-4 w-4 shrink-0 text-gold-dark" strokeWidth={2.5} />
            {p}
          </li>
        ))}
      </ul>
    </div>
  </section>
);
